export const REGISTER_USER_INFO = 'registerUserInfo';

export const EXAMINEE_ITEMS = 'examineeItems';
